<app-dialog-header [header]="'backup.dialog.generate_qr_code.header_display' | translate"></app-dialog-header>
<app-dialog-content>
  <div class="p-grid">
    <div class="p-col-12 instruction-content">
      <span [innerHTML]="'backup.dialog.generate_qr_code.instruction.text' | translate"></span>:<br><br>
      <ol>
        <li [innerHTML]="'backup.dialog.generate_qr_code.instruction.step_1' | translate"></li>
        <li [innerHTML]="'backup.dialog.generate_qr_code.instruction.step_2' | translate"></li>
        <li [innerHTML]="'backup.dialog.generate_qr_code.instruction.step_3' | translate"></li>
        <li [innerHTML]="'backup.dialog.generate_qr_code.instruction.step_4' | translate"></li>
      </ol>
    </div>
    <div class="p-col-12 align-center">
      <img
        [src]="qrCode"
        class="qr-code"
      >
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="generate-qr-code-cancel-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
</div>
